import * as Msal from "msal";

let msalConfig;

function getEnvironmentFlags() {
  let hostname = window.location.host;

  let isLocal = hostname.includes('local');
  let isStaging = hostname.includes('-h');

  let urlParams = new URLSearchParams(window.location.search);
  let debugTarget = urlParams.get('target');

  return {
    isLocal: isLocal,
    isStaging: isStaging,
    debugTarget: debugTarget
  }
}

let envFlags = getEnvironmentFlags();
let isLocal = envFlags.isLocal;
let isStaging = envFlags.isStaging;
let debugTarget = envFlags.debugTarget;

if (isLocal) {
  if (debugTarget == 'prod' || debugTarget == 'production') {
    msalConfig = {
      auth: {
        clientId: "7a7c5836-0924-42dd-9b14-1b92a9d7174a",
        authority: "https://login.microsoftonline.com/66008e68-e66e-49e4-a2e3-c800ad38fc78",
        redirectUri: window.location.origin
      }
    };
  } else { // Local
    msalConfig = {
      auth: {
        clientId: "7a7c5836-0924-42dd-9b14-1b92a9d7174a",
        authority: "https://login.microsoftonline.com/66008e68-e66e-49e4-a2e3-c800ad38fc78",
        redirectUri: window.location.origin
      }
    };
  }
} else if (isStaging) {
  msalConfig = {
    auth: {
      clientId: "7a7c5836-0924-42dd-9b14-1b92a9d7174a",
      authority: "https://login.microsoftonline.com/66008e68-e66e-49e4-a2e3-c800ad38fc78",
      redirectUri: "https://internal.safe2pay-h.com.br"
    },
  };
} else { // Production
  msalConfig = {
    auth: {
      clientId: "7a7c5836-0924-42dd-9b14-1b92a9d7174a",
      authority: "https://login.microsoftonline.com/66008e68-e66e-49e4-a2e3-c800ad38fc78",
      redirectUri: "https://internal.safe2pay.com.br"
    },
  };
}

const msalInstance = new Msal.UserAgentApplication(msalConfig);

const loginRequest = {
  scopes: ["api://ccd953f5-5f89-458b-bcb0-8b3f018f436f/Authenticate"]
};

async function loginAzureAd() {
  try {
    const loginResponse = await msalInstance.loginPopup(loginRequest);
    return loginResponse;
  } catch (err) {
    console.error("Erro no login:", err);
  }
}

async function getTokenAzureAd() {
  try {
    const tokenResponse = await msalInstance.acquireTokenSilent(loginRequest);
    return tokenResponse.accessToken;
  } catch (err) {
    console.warn("Silent token failed, tentando via popup...");
    return msalInstance.acquireTokenPopup(loginRequest).then(r => {
      if (r && r.accessToken) {
        return r.accessToken;
      } else {
        throw new Error("Access token não encontrado na resposta.");
      }
    }).catch(err => {
      console.error("Erro ao adquirir o token:", err);
      // throw err;
      return null;
    });
  }
}

export { msalInstance, loginAzureAd, getTokenAzureAd };



// WEBPACK FOOTER //
// ./src/utils/authConfig.js